export const SPARKS_PER_MINT = 777
export const WEI_PER_SPARK = 1_000_000_000_000n
export const SPARKS_PER_ETHER = 1_000_000
export const SPARK_UNITS = 12

// Round normally (up or down, whichever is closer)
export function convertWeiToSparksForDisplay(wei: string | number | bigint) {
  const quotient = BigInt(wei) / WEI_PER_SPARK
  const remainder = BigInt(wei) % WEI_PER_SPARK

  return remainder > 0 && remainder >= BigInt(wei) / 2n ? quotient + 1n : quotient
}

// Round up typically is false for display options but
export function convertWeiToSparksRoundDown(wei: string | number | bigint) {
  return BigInt(wei) / WEI_PER_SPARK
}

export function convertWeiToSparksSpendingRoundUp(wei: string | number | bigint) {
  const quotient = BigInt(wei) / WEI_PER_SPARK
  const remainder = BigInt(wei) % WEI_PER_SPARK
  return remainder > 0n ? quotient + 1n : quotient
}

export function convertSparksToWei(sparks: string | number | bigint) {
  return BigInt(sparks) * WEI_PER_SPARK
}

export const convertEtherToSparks = (ethAmount: number): number => {
  // Note: sparks should ONLY ever be shown as whole integers, since they are technically 1155
  return Math.floor(ethAmount * SPARKS_PER_ETHER)
}

export const convertSparksToEther = (sparksAmount: number): number => {
  return sparksAmount / SPARKS_PER_ETHER
}
